<ndt-phone-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [isLoading]="isLoading$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [phonePrivileges]="phonePrivileges$ | async"
   [name]="entityName"
   [columns]="columns"
   (create)="onCreate()"
   (loadMore)="onLoadMore()"
>
</ndt-phone-register-view>
